import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'

// "Inline" English and Arabic translations. 
// We can localize to any language and any number of languages.

i18next
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .use(HttpApi)
    .init({
        supportedLngs: ['en', 'th', 'jp'],
        fallbackLng: "en",
        detection: {
            order: ['cookie', 'htmlTag', 'localStorage', 'path', 'sessionStorage', 'navigator', 'subdomain'],
            caches: ['cookie'],
        },
        backend: {
            loadPath: `/assets/locales/{{lng}}/translation.json`
        },
        react: { useSuspense: false },
    });

export default i18next;